import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import VersionRouter from './components/VersionRouter';
import { useHotjar } from './helpers/useHotjar';
import { useAmplitude } from './shared/amplitude';
import { startEmbeddedViewportTracking } from './helpers/embeddedViewport';

function App() {
  useHotjar();
  useAmplitude();

  // Embedado, `100vh` é a altura do iframe e não a da área que o host de fato mostra. Isso
  // publica a faixa visível em CSS vars; fora de iframe é no-op.
  useEffect(() => startEmbeddedViewportTracking(), []);

  return (
    <Router>
      <VersionRouter />
    </Router>
  );
}

export default App;
